import tw from 'twin.macro';

export const StateContainer = tw.div`w-full h-full rounded-2xl bg-softGray flex items-center justify-between p-3`;
